import React from "react";
import {BrowserRouter, Link} from "react-router-dom";
import animateScrollTo from "animated-scroll-to";
import s from "./PhonePopup.scss";

export default class PhonePopup extends React.Component {
  constructor(props) {
    super(props);

    this.form = {};
    this.state = {
      inputPhone: "",
      validate: {
        inputPhone: true,
      },
      wasSent: false,
    };
  }

  handlePhone = (e) => {
    console.log("handle phone", e.target.value);
    this.setState({inputPhone: e.target.value});
  };

  checkPhone = (val) => {
    let pattern = new RegExp("^\\d{3}[- ]{0,1}\\d{3}[- ]{0,1}\\d{3}$");
    return pattern.test(val);
  };

  sendForm(e) {
    e.preventDefault();

    let formLocation = this.props.formLocation;
    let flatNumber = this.props.flatNumber;
    let pageLocation = window.location.href;

    if (pageLocation == "/") {
      pageLocation = "strona główna";
    }
    if (flatNumber == undefined) {
      flatNumber = "brak";
    }

    //console.log(formLocation, flatNumber, pageLocation);

    if (!this.state.wasSent) {
      var validate = {
        inputPhone: true,
      };
      var valid = true;
      for (var property in this.form) {
        if (this.form.hasOwnProperty(property)) {
          var element = this.form[property];
          
          if (element.name == "inputPhone") {
            var v = this.checkPhone(element.value);
            if (!v) valid = false;
            validate[property] = v;
          }
        }
      }

      this.setState({
        validate,
      });

      if (valid) {
        let catalogData = {
          inputPhone: this.form.inputPhone.value,
        };

        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/leave-phone", true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.send(JSON.stringify(catalogData));
        xhr.onload = () => {
          this.setState({
            wasSent: true,
          });

          for (var property in this.form) {
            if (this.form.hasOwnProperty(property)) {
              this.form[property].value = "";
            }
          }
        };
        console.log("wyslano", catalogData);
        this.props.closePopupForm()
      } else {
        console.log("didnt send");
      }
    }
  }

  render() {
    return (
      <div
        className={this.props.popupForm ? "phone-popup" : "phone-popup closed"}
      >
        <div
          onClick={() => this.props.closePopupForm()}
          className="pupup__close"
        >
          <span className="af-icon-x"></span>
        </div>

        <div className="popup__title">Masz pytania?</div>

        <div className="popup__main row">
          <div className="popup__text col-12 col-m-12">
            Zostaw numer telefonu a oddzwonimy
          </div>

          <div className="popup__column col-12 col-m-12">
            {this.state.wasSent ? (
              <div className="popup__text">
                Wiadomość została wysłana
              </div>
            ) : (
              <form className="phone__form" method="post">
                <div className="input__box">
                  <input
                    disabled={this.state.wasSent ? "disabled" : ""}
                    className={this.state.validate.inputPhone ? "" : "error"}
                    type="text"
                    ref={(input) => {
                      this.form.inputPhone = input;
                    }}
                    required
                    name="inputPhone"
                    placeholder={"Telefon: 000-000-000"}
                    onChange={(e) => this.handlePhone(e)}
                  />

                  <span
                    className={
                      this.state.validate.inputPhone
                        ? "error-box"
                        : "error-box show"
                    }
                  >
                    Wpisz poprawny numer telefonu
                  </span>
                </div>

                <div className="popup__button-container">
                  <button
                    onClick={(e) => this.sendForm(e)}
                    className="popup__button"
                  >
                    Wyślij
                  </button>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/PhonePopup/PhonePopup.js